export default __webpack_public_path__ + "static/media/drox.79ea95c1.png";